import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "dateInput", "scheduleBtn", "scheduleBtnFooter"]
  static values = {
    pro: Boolean,
    open: { type: Boolean, default: false }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.openValue = !this.openValue
    this.pickerTarget.classList.toggle("is-open", this.openValue)

    if (this.proValue && this.openValue && this.hasDateInputTarget && !this.dateInputTarget.value) {
      // Default to tomorrow at 9:00 AM
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(9, 0, 0, 0)
      this.dateInputTarget.value = this.toLocalDatetime(tomorrow)
      this.dateChanged()
    }
  }

  dateChanged() {
    if (!this.hasDateInputTarget) return

    const val = this.dateInputTarget.value
    if (!val) {
      this.resetButtons()
      return
    }

    const date = new Date(val)
    const formatted = this.formatDate(date)

    // Transform schedule buttons into submit buttons with schedule params
    this.scheduleButtonTargets.forEach(btn => {
      btn.textContent = formatted
      btn.type = "submit"
      btn.name = "schedule"
      btn.value = "true"
    })
  }

  clearDate(event) {
    event.preventDefault()
    if (!this.hasDateInputTarget) return

    this.dateInputTarget.value = ""
    this.openValue = false
    this.pickerTarget.classList.remove("is-open")
    this.resetButtons()
  }

  resetButtons() {
    const label = this.element.dataset.scheduleLabelValue || "Schedule"
    this.scheduleButtonTargets.forEach(btn => {
      btn.textContent = label
      btn.type = "button"
      btn.removeAttribute("name")
      btn.removeAttribute("value")
    })
  }

  get scheduleButtonTargets() {
    const targets = []
    if (this.hasScheduleBtnTarget) targets.push(this.scheduleBtnTarget)
    if (this.hasScheduleBtnFooterTarget) targets.push(this.scheduleBtnFooterTarget)
    return targets
  }

  formatDate(date) {
    const dateStr = new Intl.DateTimeFormat(navigator.language, {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit"
    }).format(date)
    const template = this.element.dataset.scheduleFormatValue || "Schedule for %{date}"
    return template.replace("%{date}", dateStr)
  }

  toLocalDatetime(date) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const hours = date.getHours().toString().padStart(2, "0")
    const minutes = date.getMinutes().toString().padStart(2, "0")
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
}
